import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";

import {HttpCommonService} from "../services/http-common.service";
import {NzMessageService, NzModalService} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {GlobalService} from "../services/global.service";

@Injectable()
export class EnterpGuard implements CanActivate{

  constructor(private msg: NzMessageService,
              public http: HttpCommonService,
              private globalService: GlobalService,
              private router: Router,
              private showModal: NzModalService,){}

  canActivate(routerInfo: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    let aType = routerInfo.queryParams['aType'];
    let cPath = routerInfo.routeConfig.path;
    if (cPath == "enterpIntroduction" && aType != "1") {
      return true;
    } else {
      return this.http.get("/auth/jwt/isLogin").map((result) => {
        // 已登录
        if (result.stateCode == '20111') {
          if (result.data.userType == 'enterprise') {
            return true;
          } else {
            // this.msg.error("请登录企业账号");
            // this.router.navigate(["comLR/login"], {});

            // 自动退出并调整到企业用户
            let thiss = this;
            this.showModal.warning({
              content: '该功能仅对企业入驻用户开放，您可以登录企业账号使用；若您尚无企业账号，可先申请企业入驻',
              okText: '登录企业账号',
              onOk: () => {
                this.http.get("/auth/jwt/logout").subscribe(data => {
                  //thiss.cookieService.delete("auth-token");
                  thiss.globalService.checkLoginState();
                  thiss.globalService.deleteLocalStorage();
                  thiss.globalService.isLoginedUser = false;
                });
                thiss.router.navigate(['comLR/login'], {queryParams: {'selectIndex': '1'} });
              },
              cancelText: '取消',
              onCancel: () => {

              },
            });

            return false;
          }
        }  else if (result.stateCode == '40500') {
          // 不同用户登录同一账号密码被修改时
           return true;
        }  else {
          // 企业或者个人用户
          if (this.globalService.isLoginedUser) {
            this.msg.error("您的账号已超时，请重新登录");

            // 设置未读消息不显示
            this.globalService.setKey("countShow", false);

            //this.globalService.deleteLocalStorage();
            this.globalService.isLoginedUser = false;
            this.router.navigate(["comLR/login"], {queryParams: {'selectIndex': '1'}});
          } else {
            this.msg.error("请登录企业账号");
            this.router.navigate(["comLR/login"], {queryParams: {'selectIndex': '1'}});
          }
          return false;
        }
      }).first();
    }
  }


}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/guard/EnterpGuard.ts